import React from 'react';

import { CreditRewardModal } from './CreditRewardModal';

interface SignupCreditAwardModalProps {
  amount: number | null;
  onClose: () => void;
}

export const SignupCreditAwardModal: React.FC<SignupCreditAwardModalProps> = ({ amount, onClose }) => {
  if (amount === null || !Number.isFinite(amount) || amount <= 0) return null;

  return (
    <CreditRewardModal open title="Your credits are ready!" status="Free credits unlocked" credits={amount}
      creditDescription="added to your account" message="Your reward is ready to use." action="Start building"
      busy={false} onAction={onClose} onClose={onClose} />
  );
};
